import 'moment/locale/fr';
import 'numeral/locales/fr';

import 'moment/locale/ar';
import './numeral/ar';

import 'moment/locale/zh-cn';
import './numeral/zh';

import 'moment/locale/ja';
import './numeral/ja';

import 'moment/locale/km';
import './numeral/km';

import 'moment/locale/es';
import './numeral/es';
